'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


exports.default = function (DecoratedComponent) {
    var androidKeyboardStateDecorator = function (_React$Component) {
        _inherits(androidKeyboardStateDecorator, _React$Component);

        function androidKeyboardStateDecorator(props) {
            _classCallCheck(this, androidKeyboardStateDecorator);

            var _this = _possibleConstructorReturn(this, (androidKeyboardStateDecorator.__proto__ || Object.getPrototypeOf(androidKeyboardStateDecorator)).call(this, props));

            _this.onResize = function (event) {
                _this.setState({ keyboardVisible: window.innerHeight < _this.initialWindowHeight });
            };

            _this.debouncedOnResize = (0, _lodash.debounce)(_this.onResize, 10);

            _this.state = { keyboardVisible: false };
            return _this;
        }

        _createClass(androidKeyboardStateDecorator, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
                window.addEventListener('resize', this.debouncedOnResize);
                this.initialWindowHeight = window.innerHeight;
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                window.removeEventListener('resize', this.debouncedOnResize);
            }
        }, {
            key: 'render',
            value: function render() {
                var keyboardVisible = this.state.keyboardVisible;

                return _react2.default.createElement(DecoratedComponent, _extends({ keyboardVisible: keyboardVisible }, this.props));
            }
        }]);

        return androidKeyboardStateDecorator;
    }(_react2.default.Component);

    androidKeyboardStateDecorator.propTypes = {};

    return androidKeyboardStateDecorator;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/mobile/android/androidKeyboardStateDecorator.js
// module id = 2209
// module chunks = 0